// Auto-generated search result templates map
import figureTemplate from "/home/ubuntu/template/content/search/_result.mdx";
export const figure = figureTemplate;
import articleTemplate from "/home/ubuntu/template/content/search/_result.mdx";
export const article = articleTemplate;
export default { figure, article };